import { cn } from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-[#1A3A6B]/5", className)}
      style={{
        backgroundImage: "linear-gradient(90deg, rgba(26,58,107,0) 0%, rgba(26,58,107,0.05) 50%, rgba(26,58,107,0) 100%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 2s infinite linear"
      }}
      {...props}
    />
  );
}

export { Skeleton };
